import { ActionTypes } from './types'

/// /////////////////////////////////////////////////////////////////////
export const SetLoader = () => ({ type: ActionTypes.SET_LOADER })
